
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 28","data-code":"61665","data-tags":"linkedin"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.453 9.766V25.25H.297V9.766h5.156zm.328-4.782c.016 1.485-1.11 2.672-2.906 2.672h-.031C1.109 7.656 0 6.47 0 4.984 0 3.47 1.156 2.313 2.906 2.313c1.766 0 2.86 1.156 2.875 2.671zM24 16.375v8.875h-5.14v-8.281c0-2.078-.75-3.5-2.61-3.5-1.422 0-2.266.953-2.64 1.875-.126.343-.173.797-.173 1.265v8.641h-5.14c.062-14.031 0-15.484 0-15.484h5.14v2.25h-.03c.671-1.063 1.89-2.61 4.671-2.61 3.39 0 5.922 2.219 5.922 6.969z","fill":"inherit"}})])
          )
        }
      }
    